import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import { Decimal } from '~/modules/common/components';
import { isNullOrUndefined } from '~/modules/common/util';
import { ResourceEstimateCost } from '../ResourceEstimateCost';
import { Dagger } from '../Dagger';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: theme.spacing(0, 0, 1)
  },
  label: {
    minWidth: theme.spacing(22)
  },
  valueCommon: {
    textAlign: 'right',
    fontSize: theme.typography.body2.fontSize,
    minWidth: theme.spacing(16),
    padding: theme.spacing(0, 0.5, 0, 0)
  },
  values: {
    fontWeight: theme.typography.fontWeightBold
  },
  outdatedValues: {
    color: theme.palette.text.secondary
  }
}));

const PopoverItemMetric = ({
  formattedMessageKey,
  hours,
  cost,
  canViewCost,
  showNoValue = false,
  hasValuesChanged = false
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const valueClass = hasValuesChanged
    ? classNames(classes.valueCommon, classes.outdatedValues)
    : classNames(classes.valueCommon, classes.values);

  return (
    <div className={classes.root}>
      <Typography variant="body2" className={classes.label}>
        <FormattedMessage id={formattedMessageKey} />
        {hasValuesChanged && <Dagger prefix=" " />}
      </Typography>
      {showNoValue && isNullOrUndefined(hours) ? (
        <Typography className={valueClass}>
          <FormattedMessage id="taskResourceEstimates.notApplicable" />
        </Typography>
      ) : (
        <Decimal
          className={valueClass}
          suffix={` ${formatMessage({
            id: 'taskResourceEstimates.hoursAdornment'
          })}`}
          value={hours}
        />
      )}
      {canViewCost && (
        <ResourceEstimateCost
          className={valueClass}
          hours={hours}
          cost={cost}
        />
      )}
    </div>
  );
};

PopoverItemMetric.propTypes = {
  formattedMessageKey: PropTypes.string,
  hours: PropTypes.number,
  cost: PropTypes.object,
  canViewCost: PropTypes.bool,
  showNoValue: PropTypes.bool,
  hasValuesChanged: PropTypes.bool
};

export default PopoverItemMetric;
